export const review = {
  rate: '4.0',
  total: 121,
  fiveStar: 40,
  fourStar: 63,
  threeStar: 13,
  twoStar: 5,
  oneStar: 0,
  reviewers: [
    {
      id: 1,
      account: {
        id: 1,
        name: 'Quyen Hua',
        avatar: '/link-avatar',
      },
      rate: 5,
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      imageUrls: [],
      createdDate: '2021-08-08T11:43:35Z',
    },
    {
      id: 2,
      account: {
        id: 2,
        name: 'Phu Tran',
        avatar: '/link-avatar',
      },
      rate: 4,
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      imageUrls: ['/test-image', '/test-image-1'],
      createdDate: '2021-09-08T11:43:35Z',
    },
    {
      id: 3,
      rate: 5,
      account: {
        id: 3,
        name: 'Thanh Tong',
        avatar: '/link-avatar',
      },
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      imageUrls: [],
      createdDate: '2021-02-08T11:43:35Z',
    },
    {
      id: 4,
      account: {
        id: 4,
        name: 'Tam Nguyen',
        avatar: '/link-avatar',
      },
      rate: 3,
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      imageUrls: [],
      createdDate: '2021-07-11T11:43:35Z',
    },
  ],
};

export const saleInfo = {
  saledTotal: 201,
};

export const discountCodes = [
  {
    id: 'discount-10',
    value: '10k',
  },
  {
    id: 'discount-20',
    value: '20k',
  },
  {
    id: 'discount-100',
    value: '100k',
  },
];

export default {};
